import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import {
  CircularProgress,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
} from '@mui/material';
import { ColorsV2 } from 'app/constants/color';
import apiService from 'app/services/apiService';
import { flushSync } from 'react-dom';
import ReactMarkdown from 'react-markdown';

const RecommendationPopUp = ({ open, handleClose, fwId, sectId }) => {
  const [loading, setLoading] = useState(true);
  const [content, setContent] = useState('');

  const language = JSON.parse(localStorage.getItem('lang'));

  const fetchRecommendation = async () => {
    setLoading(true);
    apiService.getAutoRecommendation(fwId, sectId, language, function (word) {
      setLoading(false);
      flushSync(() => {
        setContent(prevText => prevText + word);
      });
    });
  };

  useEffect(() => {
    if (open) {
      fetchRecommendation();
    } else {
      setContent('');
    }
  }, [open]);

  const { t } = useTranslation('translation', { keyPrefix: 'gap_analysis' });

  return (
    <div>
      <Dialog open={open} onClose={handleClose}>
        <DialogTitle
          sx={{
            bgcolor: ColorsV2.primary,
            color: ColorsV2.white,
          }}
        >
          {t('recommendation')}
        </DialogTitle>
        <DialogContent
          sx={{
            bgcolor: ColorsV2.primary,
          }}
        >
          {loading ? (
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                minHeight: '100px',
              }}
            >
              <Typography color={ColorsV2.white}>{t('generating_recommendation')}</Typography>
              <CircularProgress />
            </div>
          ) : (
            <Typography color={ColorsV2.white}>
              <ReactMarkdown>{content}</ReactMarkdown>
            </Typography>
          )}
        </DialogContent>
        <DialogActions
          sx={{
            bgcolor: ColorsV2.primary,
          }}
        >
          <Button
            onClick={handleClose}
            sx={{
              color: ColorsV2.acent,
              '&:hover': {
                color: ColorsV2.white,
                bgcolor: ColorsV2.acent,
              },
            }}
          >
            {t('close')}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default RecommendationPopUp;
